module.exports = __webpack_public_path__ + "static/media/MrTaoTan.3eb9cc3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/comp/sub1/MrTaoTan.jpg
// module id = 196
// module chunks = 0